import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Loading from "react-fullscreen-loading";
import { ToastContainer } from "react-toastify";
import { LOADING_CAPTION } from "../../util/constant";
import { LoaderIndex } from "../../components/Loader/LoaderIndex";
import { showToast } from "../../util/toastHelper";
import { CallWithAuth } from "../../action/apiActions";
import { APPROVE_PATIENT_REPORT, EDIT_PATIENT_REPORT, GENERATE_PATIENT_REPORT, GET_PROMPTS_BY_TEMPLATE, PATIENT_PAITENT_REPORT_API_URL } from "../../action/apiPath";
import { marked } from "marked";
import { convertImageToBase64, reportDateDwonaloadDateFormat } from "../../util/custom";
import logo from "../../assets/img/logo.svg";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import fileDownload from "js-file-download";

const PatientReportInformationPageTemplateClaude = () => {
  const { id: patientId } = useParams()
  const searchParams = useSearchParams();
  const [template, setTemplate] = useState();
  const [isPromptLoaded, setIsPromptLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [editing, setEditing] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [report, setReport] = useState();
  const [reportMarkdown, setReportMarkdown] = useState('');
  const [reportGenerated, setReportGenerated] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [approving, setApproving] = useState(false);
  const [isReportDownload, setIsReportDownload] = useState("");
  const [isReportDocDownload, setIsReportDocDownload] = useState("");
  const textareaRef = useRef(null)
  const [instructions, setInstructions] = useState();

  const getPrompt = async () => {
    const templateId = searchParams[0].get("templateId");
    if (!templateId) {
      return;
    }
    
    try {
      const response = await CallWithAuth(
        "GET",
        `${GET_PROMPTS_BY_TEMPLATE}?templateId=${templateId}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        setTemplate(response.res.data.data);
        setIsPromptLoaded(true);
      } else {
        showToast('error', 'Error in loading template');
        setIsPromptLoaded(false);
      }
    } catch (error) {
      showToast('error', 'Error in loading template');
      setIsPromptLoaded(false);
    }
  };

  const getReport = async () => {
    try {
      setIsLoading(true);
      const response = await CallWithAuth("GET", `${PATIENT_PAITENT_REPORT_API_URL}${patientId}`);
      if (response?.res?.data?.statusCode == 200 || response?.res?.data?.statusCode == 201) {
        if (response?.res?.data?.data?.is_approved) {
          const _report = response?.res?.data?.data?.report || '';
          setReport(_report);
          setReportMarkdown(marked(_report));
          if (_report) {
            setReportGenerated(true);
            setIsApproved(true);
          } else {
            generateReport();
          }
        } else {
          generateReport();
        }
      } else {
        const message = response?.res?.data?.message || 'Something went wrong';
        showToast("error", message);
      }
    } catch (err) {
      showToast("error", 'Something went wrong');
    }

    setIsLoading(false);
  };

  const generateReport = async () => {
    const templateId = searchParams[0].get("templateId");
    if (!templateId) {
      showToast("error", "Something went wrong!");
      return
    }

    try {
      setIsGeneratingReport(true);
      const response = await CallWithAuth("POST", `${GENERATE_PATIENT_REPORT}${patientId}/${templateId}`, {});
      if (response?.res?.data?.statusCode == 200 || response?.res?.data?.statusCode == 201) {
        const _report = response?.res?.data?.data?.report || '';
        setReport(_report);
        setReportMarkdown(marked(_report));
        if (_report) {
          setReportGenerated(true);
        }
      } else {
        const message = response?.res?.data?.message || 'Something went wrong';
        showToast("error", message);
      }
    } catch (err) {
      showToast("error", 'Something went wrong');
    }

    setIsGeneratingReport(false);
  };

  const editReport = async () => {
    const templateId = searchParams[0].get("templateId");
    if (!templateId) {
      showToast("error", "Something went wrong!");
      return
    }

    let instruction = textareaRef.current.value;
    if (!instruction) {
      showToast('error', 'Instruction is required');
      return;
    }

    try {
      setIsGeneratingReport(true);
      const response = await CallWithAuth(
        "POST", 
        `${EDIT_PATIENT_REPORT}${patientId}`, 
        {
          report_text: report,
          instructions: instruction,
          templateId: templateId
        }
      );
      
      if (response?.res?.data?.statusCode == 200 || response?.res?.data?.statusCode == 201) {
        const _report = response?.res?.data?.data?.report || '';
        setReport(_report);
        setReportMarkdown(marked(_report));
        if (_report) {
          setEditing(false);
        }
      } else {
        const message = response?.res?.data?.message || 'Something went wrong';
        showToast("error", message);
      }
    } catch (err) {
      showToast("error", 'Something went wrong');
    }

    setIsGeneratingReport(false);
  }; 

  useEffect(() => {
    if (isPromptLoaded) {
      getReport();
    }
  }, [isPromptLoaded]);

  useEffect(() => {
    getPrompt();
  }, []);

  const handleApprove = async () => {
    const r = window.confirm("Are you sure?");
    if (r === true) {
      try {
        setApproving(true);
        const response = await CallWithAuth(
          "PATCH", 
          `${APPROVE_PATIENT_REPORT}${patientId}`, 
          {
            templateId: searchParams[0].get("templateId"),
            report: report
          }
        );
        if (response?.res?.data?.statusCode == 200 || response?.res?.data?.statusCode == 201) {
          setIsApproved(response?.res?.data?.data?.is_approved);
          showToast("success", response?.res?.data?.message || "Report saved");
        } else {
          const message = response?.res?.data?.message || 'Something went wrong';
          showToast("error", message);
        }
      } catch (error) {

      }

      setApproving(false);
    }
  };

  const handleDownloadPdf = async () => {
    setIsReportDownload(true);

    const formattedHtml = reportMarkdown;
    let base64Logo = await convertImageToBase64(logo);

    const convertedContent = htmlToPdfmake(formattedHtml);
    const docDefinition = {
      pageSize: "A4", // Default is A4
      pageOrientation: "prtrait", // Set landscape mode
      content: [
        {
          image: base64Logo, // Insert the Base64 logo
          width: 100, // Adjust size
          alignment: "center", // Center align the logo
          margin: [0, 0, 0, 20], // Space below the logo
        },
        convertedContent, // Insert the formatted content
      ],
    };
    
    const filename = `document_${reportDateDwonaloadDateFormat()}.pdf`;

    // Now use pdfmake to generate PDF
    pdfMake.createPdf(docDefinition).download(filename);
    setIsReportDownload(false);
  };

  const handleDownloadDoc = async () => {
    setIsReportDocDownload(true);
    const formattedHtml = reportMarkdown
    let base64Logo = await convertImageToBase64(logo);

    const filename = `document_${reportDateDwonaloadDateFormat()}.doc`;

    // Add logo to HTML using <img>
    const logo_section_html = `
      <div style="text-align: center; margin-bottom: 20px;">
        <img src="${base64Logo}" alt="Logo" style="width: 150px; height: auto;" />
      </div>
    `;

    // Convert HTML to Blob
    const blob = new Blob(
      [
        `<html>
          <head>
            <meta charset="UTF-8">
            <title>Document</title>
          </head><body>${logo_section_html}${formattedHtml}</body>
        </html>`,
      ],
      { type: "application/msword" }
    );

    // Option 1: Use js-file-download (Optional)
    fileDownload(blob, filename);
    setIsReportDocDownload(false);
  };

  return (
    <div className="create_account_block" style={{ padding: "0" }}>
      <div className="site_container">
        <div className="create_account_form">
          <div className="report-container-main px-0">
            <h1>Report</h1>
            <div
              className="report-container-child-cls typing"
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  padding: "24px",
                  background: "#F9FAFC",
                  borderRadius: "10px",
                  width: "100%",
                  display: isGeneratingReport ? 'none' : ''
                }}
                className="form-group report-container-new"
                dangerouslySetInnerHTML={{
                  __html: reportMarkdown
                }}
              />
              {isLoading || isGeneratingReport ? (
                <div className="loader-with-text">
                  <div className="loader-div">
                    <LoaderIndex />
                  </div>
                  <div className="text-div loading-text">
                    {isGeneratingReport ? 'Generating Reports' : ''}
                    <span className="dots">
                      <span>.</span>
                      <span>.</span>
                      <span>.</span>
                    </span>
                  </div>
                </div>
              ) : null}

              {reportGenerated && !isApproved ? (
                !editing ? (
                  <div className="d-flex" style={{ marginBottom: "20px" }}>
                    <button
                      onClick={() => setEditing(true)}
                      className="approve-report-button"
                    >
                      Edit
                      {approving && (
                        <>
                          {""}
                          <LoaderIndex />
                        </>
                      )}
                    </button>
                    <button
                      onClick={handleApprove}
                      className="approve-report-button"
                      disabled={approving}
                    >
                      Approve
                      {approving && (
                        <>
                          {""}
                          <LoaderIndex />
                        </>
                      )}
                    </button>
                  </div>
                ): (
                  <>
                    <div className="mt-3 relative">
                      <textarea
                        ref={textareaRef}
                        className="form-control pr"
                        rows={4}
                        value={instructions}
                        onChange={(e) => setInstructions(e.target.value)}
                      />
                    </div>

                    <div className="mt-2 d-flex gap-2">
                      <button
                        className="btn btn-primary"
                        onClick={editReport}
                        disabled={isGeneratingReport}
                      >
                        Update
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() => setEditing(false)}
                        disabled={isGeneratingReport}
                      >
                        Cancel
                      </button>
                    </div>
                  </>
                )
              ) : null}


              {reportGenerated && isApproved && (
                <>
                  <div className="d-flex" style={{ marginBottom: "20px" }}>
                    <button
                      onClick={handleDownloadPdf}
                      className="approve-report-button"
                      disabled={isReportDownload}
                    >
                      Download as PDF Report{" "}
                      {isReportDownload && (
                        <>
                          {""}
                          <LoaderIndex />
                        </>
                      )}
                    </button>
                    <button
                      onClick={handleDownloadDoc}
                      className="approve-report-button"
                      disabled={isReportDocDownload}
                    >
                      Download as Doc Report{" "}
                      {isReportDocDownload && (
                        <>
                          {""}
                          <LoaderIndex />
                        </>
                      )}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>

          <ToastContainer />
        </div>
      </div>
    </div>
  );
};

export default PatientReportInformationPageTemplateClaude;
